var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditarClave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rect\\xE1ngulo_1855",
    x: 4.75,
    y: 7,
    width: 149,
    height: 149,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.09
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-editar-clave"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 158
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editar-clave",
    clipPath: "url(#clip-editar-clave)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1854",
    "data-name": "Rect\\xE1ngulo 1854",
    width: 153,
    height: 153,
    rx: 75,
    transform: "translate(2.75 3)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Rect\\xE1ngulo_1855)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1855-2",
    "data-name": "Rect\\xE1ngulo 1855",
    width: 137,
    height: 137,
    rx: 68.5,
    transform: "translate(10.75 11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ic_lock_24px",
    d: "M48.583,23.292H45.4V16.923a15.923,15.923,0,1,0-31.845,0v6.369H10.369A6.388,6.388,0,0,0,4,29.661V61.506a6.388,6.388,0,0,0,6.369,6.369H48.583a6.388,6.388,0,0,0,6.369-6.369V29.661A6.388,6.388,0,0,0,48.583,23.292ZM29.476,51.952a6.369,6.369,0,1,1,6.369-6.369A6.388,6.388,0,0,1,29.476,51.952Zm9.872-28.661H19.6V16.923a9.872,9.872,0,0,1,19.744,0Z",
    transform: "translate(49.5 44.125)",
    fill: "#3f4d71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditarClave);
export default __webpack_public_path__ + "static/media/editar-clave.fdc20717a3985f08d31d70266a57f019.svg";
export { ForwardRef as ReactComponent };